import { fetchSent, deleteSent } from "@/api/sentService";

export default {
  //Fetch sent
  async fetchSent({ commit }, pageNumber) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });

      const response = await fetchSent(pageNumber);
      const sent = response.data.data;
      commit("SET_SENT_DATA", sent);
      commit("SET_SENT_RECORDS", response.data.data.totalRecords);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Your sent sms arrived.",
          color: "success",
        },
        { root: true }
      );
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.message || "Something went wrong",
          color: "error",
        },
        { root: true }
      );
    }
  },

  //Delete sent
  async deleteSent(context, payload) {
    context.commit("SHOW_PROGRESSBAR", true, { root: true });
    await deleteSent(payload);
    const pageNumber = context.state.sent.currentPage;
    context.dispatch("fetchSent", pageNumber);
    context.commit("HIDE_PROGRESSBAR", false, { root: true });
    context.commit(
      "SHOW_SNACKBAR",
      {
        text: "Record deleted!",
        color: "success",
      },
      { root: true }
    );
  },
};
